<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <Address v-if="state === 'ADDRESS'" v-bind:location-change-callback="locationChange" />
      <ServicesBook v-if="state === 'SERVICESBOOK'" :goBack="backStep" @proceed="proceedToChecklist"/>
      <Checklist v-if="state === 'CHECKLIST'" :goBack="backStep" :serviceType="selectedService" @proceed="proceedToConfirm"/>
      <!-- <WasteType v-if="state === 'WASTE_TYPE'" v-bind:waste-types="wasteTypes" v-bind:proceed="wasteTypeChange" v-bind:goBack="backStep"/>
      <ServiceType v-if="state === 'SERVICE_TYPE'" v-bind:vehicles="serviceTypes" v-bind:proceed="serviceTypeChange" v-bind:goBack="backStep"/>
      <ContactDetails v-if="state === 'CONTACT_DETAILS'"
                      v-bind:waste-type="selectedWasteType"
                      v-bind:vehicle="selectedVehicle"
                      v-bind:captured-address="capturedAddress"
                      v-bind:service-provider-id="serviceProviderId"
                      v-bind:location="location"
                      v-bind:postCode="postCode"
                      v-bind:nextStep="nextStep"
                      v-bind:goBack="backStep"
        /> -->
        <ConfirmInfo 
          v-if="state === 'CONFIRM'" 
          v-bind:goBack="backStep"
          :address1="collectionAddress"
          :address2="deliveryAddress"
          :serviceType="selectedService"
          :truckType="selectedTruck"
          :user="user"
          :living_room_items="living_room_items"
          :dinning_room_items="dinning_room_items"
          :bedroom_items="bedroom_items"
          :kitchen_items="kitchen_items"
          :storage_items="storage_items"
          :other_items="other_items" 
          :special_instructions="special_instructions"
          />
    </v-row>

    <v-row v-if="loading">
      <v-col cols="3" align="center">
        <Loading/>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import Address from '@/components/fast-quote/Address';
import ServicesBook from '@/components/fast-quote/ServicesBook.vue';
import Checklist from '@/components/fast-quote/Checklist.vue';
// import WasteType from '@/components/fast-quote/WasteType';
// import ServiceType from '@/components/fast-quote/ServiceType';
import ConfirmInfo from '@/components/fast-quote/ConfirmInfo';
// import ContactDetails from '@/components/fast-quote/ContactDetails';
import Loading from '@/components/Loading';

const FAST_QUOTE_STATE = ['ADDRESS', 'SERVICESBOOK', 'CHECKLIST', 'CONFIRM'];

export default {
  name: "FastQuote",
  components: { 
    Loading, 
    Address,
    ServicesBook,
    Checklist,
    // ContactDetails, 
    // ServiceType, 
    // WasteType, 
    ConfirmInfo, 
  },
  data () {
    return {
      loading: false,
      user: {},
      location: {},
      postCode: '',
      collectionAddress: null,
      deliveryAddress: null,
      step: 0,
      state: FAST_QUOTE_STATE[0],
      selectedService: null,
      selectedTruck: null,
      living_room_items: [],
      dinning_room_items: [],
      bedroom_items: [],
      kitchen_items: [],
      storage_items: [],
      other_items: "",
      special_instructions: "",
    }
  },
  methods: {
    scrollToTop(){
      setTimeout(() => {
        scroll(0, 0);
      }, 0)
    },
    backStep(){
      this.step--;
      this.state = FAST_QUOTE_STATE[this.step];
    },
    nextStep(){
      this.step++;
      this.state = FAST_QUOTE_STATE[this.step];
      this.scrollToTop();

      // if(this.step > 0){
      //   this.$emit('showInfo', true);
      // }
      // if(this.step == 4){
      //   this.$emit('step4', true);
      // }

    },
    async locationChange(address1, address2) {
      this.collectionAddress = address1;
      this.deliveryAddress = address2;
      this.nextStep();      
    },
    proceedToChecklist(data) {
      this.selectedService = data.service;
      this.selectedTruck = data.truck;
      this.user.emailAddress = data.emailAddress;
      this.user.mobile = data.mobile;
      this.nextStep();
    },
    proceedToConfirm(data){
      this.living_room_items = data.selected_living_room_items;
      this.dinning_room_items = data.selected_dinning_room_items;
      this.bedroom_items = data.selected_bedroom_items;
      this.kitchen_items = data.selected_kitchen_items;
      this.storage_items = data.selected_storage_items;
      this.other_items = data.other_items;
      this.special_instructions = data.special_instructions;
      this.nextStep();
    }
  },
  computed: {
  },
  watch: {

  },
  mounted(){
  }
}
</script>
